import { render } from "./CoBrandCanvas.vue?vue&type=template&id=436e1dbe&scoped=true"
import script from "./CoBrandCanvas.vue?vue&type=script&lang=js"
export * from "./CoBrandCanvas.vue?vue&type=script&lang=js"

import "./CoBrandCanvas.vue?vue&type=style&index=0&id=436e1dbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436e1dbe"]])

export default __exports__